<template>
  <div>
    <v-dialog v-model="value" scrollable persistent max-width="1000px">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('input', false)"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="totalGroup">
            <v-layout row wrap>
              <template v-for="n in totalGroup">
                <v-flex xs6 sm4 md4 lg2 :key="`group_${n}`" class="pa-2 text-xs-center">
                  <div class="z-border-red py-3">
                    <v-icon x-large>folder_shared</v-icon>
                    <div small>
                      {{ ((n - 1) * limit + 1) | numberFormat }} -
                      <template v-if="n == totalGroup">
                        {{ total | numberFormat }}
                      </template>
                      <template v-else>{{ (n * limit) | numberFormat }}</template>
                    </div>
                    <v-btn color="primary" small @click="exportxlsx(n, limit)">{{
                      $t('Download')
                    }}</v-btn>
                  </div>
                </v-flex>
              </template>
            </v-layout>
          </template>
          <template v-else>
            <div class="text-xs-center my-5">
              <slot name="empty"> No data </slot>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import XLSX from 'xlsx'
export default {
  props: {
    value: {},
    total: {
      default: 0
    },
    limit: {
      default: 10000
    },
    filename: {
      default: 'untitled'
    }
  },
  computed: {
    totalGroup() {
      if (!this.total) return 0
      return Math.ceil(this.total / this.limit)
    }
  },
  methods: {
    async exportxlsx(n, limit) {
      let vm = this
      this.$emit('onExport', {
        page: n,
        limit: limit,
        offset: (n - 1) * limit,
        submitData: function (json) {
          const dataWS = XLSX.utils.json_to_sheet(json)
          vm.handleWriteFile(dataWS)
          return true
        },
        submitAoaData: function (aoa) {
          const dataWS = XLSX.utils.aoa_to_sheet(aoa)
          vm.handleWriteFile(dataWS)
          return true
        }
      })
    },
    handleWriteFile(data) {
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, data)
      XLSX.writeFile(wb, `${this.filename}.xlsx`)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/ExportGroup.vue